<form [formGroup]="fg" class="flex_wrap gap_large" tabindex="0" role="form" aria-label="Filtrado de preguntas">
	<div class="half_width">
		<mat-form-field class="no_vertical_spacing">
			<input matInput type="text" formControlName="textInput" placeholder="Buscar preguntas">
			<mat-icon matPrefix>search</mat-icon>
		</mat-form-field>
	</div>
	<div class="half_width">
		<mat-form-field class="no_vertical_spacing">
			<mat-select formControlName="status">		<!-- Sin placeholder porque arranca con valor por defecto-->
				<mat-option *ngFor="let qs of eQuestionStatus | properEnumPipe" [value]="qs.value">{{qs.key}}</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</form>